import type { FaireProductEntity } from "../../entity_types/product";

export const p_tch3xnthsx: FaireProductEntity = {
  token: "p_tch3xnthsx",
  type: "product",
  name: "Herbal Gut Health",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl:
    "https://cdn.faire.com/fastly/6c8e8c09df52a6960d53557096806330a0592a5b84e9f6a529793729421b14e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/39cf1c650e1fed266b8a7bfa064c602fe6e5e29f82193788d9f87b85629e2d9f.jpeg",
    "https://cdn.faire.com/fastly/48f4a156bedec0e8d1fddc0756ead5c6c00e996e1840377be7bcceffd0b4034a.jpeg",
    "https://cdn.faire.com/fastly/a25e5a70e2a3b9376a789beee424912c721c9a463874d8bc6af9ef311c70e7e0.jpeg",
    "https://cdn.faire.com/fastly/8e03bccb2b0f38e0b806cd7fee55cbe0504086073e64a061436f6e9c93041a30.jpeg",
    "https://cdn.faire.com/fastly/1e27766799a5de20765385efead683e55c57bd82269a2c2545c82cf8c6bc056a.jpeg",
  ],
  priceDollars: 17.32,
  description:
    "From the bestselling author of Body into Balance, clinical herbalist Maria Noël Groves offers a comprehensive guide to the best herbs and natural practices to boost your gut microbiome, decrease your risk of chronic disease, and alleviate conditions like SIBO, leaky gut, irritable bowel syndrome, and GERD. A healthy gut is the key to good overall health—both physical and mental—and researchers are beginning to uncover the links between an unbalanced gut microbiome and chronic conditions such as inflammatory bowel disease, obesity, and cancer. As a clinical herbalist with decades of experience, Maria Noël Groves has helped patients of all ages resolve their digestive complaints and related health issues by teaching them how to adopt healthier dietary habits, employ herbs to alleviate digestive issues and improve digestion, and incorporate balanced lifestyle practices—resolving their diseases and dramatically improving their quality of life.",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:10.975Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
